import React, { useState } from "react";
const SocketContext = React.createContext({});
const SocketProvider = (props) => {

  const [socketInstance, setSocketInstance] = useState(null);
  const [messageRead, setMessageRead] = useState(false);
  const [notifiactioCount, setNotifiactionCount] = useState(false);
  const [allNotifiaction, setAllNotifiaction] = useState([]);
  const [mentions, setMentions] = useState([]);
  const [taskManager, setTaskManager] = useState(false);



  const authContextValue = {
    socketInstance,
    setAllNotifiaction,
    setSocketInstance,
    setMentions,
    mentions,
    allNotifiaction,
    notifiactioCount,
    setNotifiactionCount,
    messageRead,
    setMessageRead,
    taskManager,
    setTaskManager
  };

  return <SocketContext.Provider value={authContextValue} {...props} />;
};

const useSocketInstance = () => React.useContext(SocketContext);

export { SocketProvider, useSocketInstance };
